const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (token, user) => ({
    type: actions.LOGIN_REQUEST,
    payload: { token, user },
  }),
  loginSuccess: (token, user) => ({
    type: actions.LOGIN_SUCCESS,
    payload: { token, user },
  }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
